<div class="flex flex-col -m-6">

  <!-- Header -->
  <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">
      {{ data.form.caption | localize }}
    </div>
    @if (data.form.oid) {
      <div class="flex flex-col justify-end items-end flex-auto ml-6">
        <div class="flex p-4">
          @if (viewForm) {
            <button mat-stroked-button class="mr-4" (click)="viewForm = false">
              {{ 'moreInfo' | transloco }}
            </button>
          }
          @if (!viewForm) {
            <button mat-stroked-button class="mr-4" (click)="viewForm = true">
              {{ 'viewForm' | transloco }}
            </button>
          }
        </div>
      </div>
    }
    <div class="flex justify-end items-end">
      <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
        <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
      </button>
    </div>
  </div>

  @if (showBOPreview) {
    <!-- Content -->
    <div class="flex flex-col flex-auto p-6 sm:p-8" fuseScrollbar>
      @if (viewForm) {
        @if (dtypeForm && viewForm) {
          <dtype-details [dtypeForm]="dtypeForm" [isUpdate]="true" [item]="dtypeData">
          </dtype-details>
        }
      } @else {
        <div class="flex flex-col justify-between mb-2 px-2">
          <!-- Title -->
          <div class="text-lg font-medium mb-2">
            {{ 'generalTableData' | transloco }}
          </div>
          <!-- Header -->
        <div class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] z-10 text-sm top-0 grid gap-4 py-4 px-4 sm:px-6 shadow text-md font-semibold text-secondary
                    bg-gray-50 dark:bg-slate-900">
            @for (object of returnObjectValues(tableData); track object) {
              <div class="flex items-center">
                {{ object.label }}
              </div>
            }
          </div>
          <!-- Rows -->
          <ng-container>
            <div
              class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] items-center gap-4 py-3 px-4 sm:px-6 border-b">
              @for (object of returnObjectValues(tableData); track object) {
                <div class="flex items-center text-center">
                  {{object.value}}
                </div>
              }
            </div>
          </ng-container>
          <!-- Title -->
          <div class="text-lg font-medium mt-8 mb-2">
            {{ 'datesTableData' | transloco }}
          </div>
          <!-- Header -->
        <div class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] z-10 text-sm top-0 grid gap-4 py-4 px-4 sm:px-6 shadow text-md font-semibold text-secondary
            bg-gray-50 dark:bg-black dark:bg-opacity-5">
            @for (object of returnObjectValues(tableDates); track object) {
              <div class="flex items-center">
                {{ object.label }}
              </div>
            }
          </div>
          <!-- Rows -->
          <ng-container>
            <div
              class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] items-center gap-4 py-3 px-4 sm:px-6 border-b">
              @for (object of returnObjectValues(tableDates); track object) {
                <div class="flex items-center text-center">
                  {{object.value}}
                </div>
              }
            </div>
          </ng-container>
          <!-- Title -->
          <div class="text-lg font-medium mt-8 mb-2">
            Uris
          </div>
          <!-- Header -->
          @for (object of returnObjectValues(tableUris); track object) {
            <div class="flex items-center mt-2 grid uris-grid  border-b border-t">
            <div class="z-10 top-0 grid gap-4 py-3 px-4 sm:px-6 font-semibold text-secondary
            bg-gray-50 dark:bg-black dark:bg-opacity-5">
                {{ object.label }}
              </div>
              <!-- Rows -->
              <ng-container>
                <div
                  class="items-center gap-4 py-3 px-4 sm:px-6">
                  <div class="flex">
                    {{object.value}}
                  </div>
                </div>
              </ng-container>
            </div>
          }
        </div>
      }
    </div>
    <!-- Actions -->
    @if (viewForm && !data.readonly) {
      <div class="flex flex-row justify-end pt-4">
        <button mat-flat-button class="mr-8" color="warn" (click)="closeDialog()">{{ 'cancel' | transloco }}</button>
        <button mat-flat-button class="mr-8" color="primary" (click)="save()">{{ 'save' | transloco }}</button>
      </div>
    }
  } @else {
    <div class="flex flex-col flex-auto items-center p-6 sm:p-8" fuseScrollbar>
      @if (viewForm) {
        <div class="flex justify-center gap-2">
          <mat-button-toggle-group [(ngModel)]="ionicMode" (change)="changeMode()">
            <mat-button-toggle checked="true" value="md">Android</mat-button-toggle>
            <mat-button-toggle value="ios">iOS</mat-button-toggle>
          </mat-button-toggle-group>
          <button mat-icon-button (click)="reloadIframe()">
            <mat-icon [svgIcon]="'mat_outline:refresh'"></mat-icon>
          </button>
        </div>
        @if (ionicMode === 'md') {
          <div class="preview-device md">
            <figure>
              @if (previewDeviceUrl) {
                <iframe id="deviceIframe" loading="lazy" importance="low" [src]="previewDeviceUrl"></iframe>
              }
            </figure>
          </div>
        }
        @if (ionicMode === 'ios') {
          <div class="preview-device ios">
            <figure>
              <!-- <svg class="ios-notch" viewBox="0 0 219 31">
              <path d="M0 1V0h219v1a5 5 0 0 0-5 5v3c0 12.15-9.85 22-22 22H27C14.85 31 5 21.15 5 9V6a5 5 0 0 0-5-5z" fill-rule="evenodd"></path>
            </svg> -->
            @if (previewDeviceUrl) {
              <iframe id="deviceIframe" loading="lazy" importance="low" [src]="previewDeviceUrl"></iframe>
            }
          </figure>
        </div>
      }
    } @else {
      <div class="flex flex-col justify-between mb-2 px-2">
        <!-- Title -->
        <div class="text-lg font-medium mb-2">
          {{ 'generalTableData' | transloco }}
        </div>
        <!-- Header -->
        <div class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] z-10 text-sm top-0 grid gap-4 py-4 px-4 sm:px-6 shadow text-md font-semibold text-secondary
                    bg-gray-50 dark:bg-slate-900">
          @for (object of returnObjectValues(tableData); track object) {
            <div class="flex items-center">
              {{ object.label }}
            </div>
          }
        </div>
        <!-- Rows -->
        <ng-container>
          <div
            class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] items-center gap-4 py-3 px-4 sm:px-6 border-b">
            @for (object of returnObjectValues(tableData); track object) {
              <div class="flex items-center text-center">
                {{object.value}}
              </div>
            }
          </div>
        </ng-container>
        <!-- Title -->
        <div class="text-lg font-medium mt-8 mb-2">
          {{ 'datesTableData' | transloco }}
        </div>
        <!-- Header -->
        <div class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] z-10 text-sm top-0 grid gap-4 py-4 px-4 sm:px-6 shadow text-md font-semibold text-secondary
            bg-gray-50 dark:bg-black dark:bg-opacity-5">
          @for (object of returnObjectValues(tableDates); track object) {
            <div class="flex items-center">
              {{ object.label }}
            </div>
          }
        </div>
        <!-- Rows -->
        <ng-container>
          <div
            class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] items-center gap-4 py-3 px-4 sm:px-6 border-b">
            @for (object of returnObjectValues(tableDates); track object) {
              <div class="flex items-center text-center">
                {{object.value}}
              </div>
            }
          </div>
        </ng-container>
        <!-- Title -->
        <div class="text-lg font-medium mt-8 mb-2">
          Uris
        </div>
        <!-- Header -->
        @for (object of returnObjectValues(tableUris); track object) {
          <div class="flex items-center mt-2 grid uris-grid  border-b border-t">
            <div class="z-10 top-0 grid gap-4 py-3 px-4 sm:px-6 font-semibold text-secondary
            bg-gray-50 dark:bg-black dark:bg-opacity-5">
              {{ object.label }}
            </div>
            <!-- Rows -->
            <ng-container>
              <div
                class="items-center gap-4 py-3 px-4 sm:px-6">
                <div class="flex">
                  {{object.value}}
                </div>
              </div>
            </ng-container>
          </div>
        }
      </div>
    }
  </div>
}

</div>


